import { Injectable } from '@angular/core';

import { DcTypes, Feature, TypedFeatureProperties } from '../../../../projects/client';
import { FeatureValueStrategy } from './feature-value-strategy.model';

@Injectable({ providedIn: 'root' })
export class StringValueStrategy implements FeatureValueStrategy {
  supports(
    feature: Feature<TypedFeatureProperties<string>, unknown>,
    propertyName: string
  ): boolean {
    const property = feature?.properties?.[propertyName];

    return property?.type === DcTypes.string && typeof property?.unit === 'undefined';
  }

  transformValue(
    feature: Feature<TypedFeatureProperties<string>, unknown>,
    propertyName: string
  ): string {
    return feature.properties?.[propertyName]?.value;
  }
}
